module.exports = __webpack_public_path__ + "static/media/green-light.b5a5934a.svg";